class Slider {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    var swiperWorks = new Swiper('.c-swiper-works', {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 14,
      navigation: {
        prevEl: ".c-works-prev",
        nextEl: ".c-works-next"
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        }
      },
    });

    var swiperFlow = new Swiper('.c-swiper-flow', {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 14,
      loop: false,
      loopFillGroupWithBlank: true,
      breakpoints: {
        768: {
          slidesPerView: 2.4,
          spaceBetween: 50,
          centeredSlides: false,
        }
      },
      navigation: {
        prevEl: ".s-flow-prev",
        nextEl: ".s-flow-next"
      },
      on: {
        init: function () {
          addEmptySlides(this);
          updatePagination(this);
          toggleNextButton(this);
        },
        slideChange: function () {
          updatePagination(this);
          toggleNextButton(this);
        }
      }
    });

    function addEmptySlides(swiper) {
      const slides = swiper.slides;
      const slidesPerView = swiper.params.slidesPerView;
      const emptySlides = Math.ceil(slidesPerView) - 1;

      if (window.innerWidth >= 768) {
        for (let i = 0; i < emptySlides; i++) {
          swiper.appendSlide('<li class="swiper-slide"></li>');
        }

        swiper.update();
      }
    }

    function updatePagination(swiper) {
      const bullets = document.querySelectorAll('.js-swiper-num li');
      bullets.forEach((bullet, index) => {
        if (index === swiper.activeIndex) {
          bullet.classList.add('active');
        } else {
          bullet.classList.remove('active');
        }
      });
    }

    function toggleNextButton(swiper) {
      const nextButton = document.querySelector('.s-flow-next');
      if (swiper.activeIndex >= 3) {
        nextButton.classList.add('swiper-button-disabled');
        nextButton.setAttribute('aria-disabled', 'true');
        nextButton.style.pointerEvents = 'none'; // ボタンのクリックを無効にする
      } else {
        nextButton.classList.remove('swiper-button-disabled');
        nextButton.setAttribute('aria-disabled', 'false');
        nextButton.style.pointerEvents = 'auto'; // ボタンのクリックを有効にする
      }
    }

    document.querySelectorAll('.js-swiper-num li').forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        swiperFlow.slideTo(index);
      });
    });
  }
}
